import DeductionDrawer from "./DeductionDrawer";

const DeductionDrawerMain = () => {
  return <DeductionDrawer />;
};

export default DeductionDrawerMain;
